import React from 'react';
import { getThermometerHeight } from '../../../helpers/boh_spotlights.js';
import ThermometerAsset from '../../../../assets/thermometer.js';
import './Thermometer.scss';
const _formatDollar = value => {
  return value.toLocaleString('US', {
    currency: 'USD',
    maximumFractionDigits: 0
  });
};
const getDescriptionValue = percentage => {
  let description = 'KEEP SELLING!';
  if (percentage > 40) {
    description = 'HALFWAY THERE!';
  }
  if (percentage > 70) {
    description = 'ALMOST THERE!';
  }
  if (percentage >= 100) {
    description = 'GOAL REACHED!';
  }
  return description;
};
const Thermometer = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className,
    value,
    goal,
    body_color,
    goal_description,
    shouldAnimate,
    byUnits
  } = props;
  const percentage = value < goal ? value * 100 / goal : 100;
  const descriptionValue = getDescriptionValue(percentage);
  const defaultStyles = {
    reached: shouldAnimate ? {
      opacity: 0
    } : {
      opacity: 1
    },
    tubeContainer: shouldAnimate ? {
      height: 0
    } : {
      height: `${getThermometerHeight(percentage)}px`
    },
    message: shouldAnimate ? {
      opacity: 1
    } : {
      opacity: percentage === 100 ? 0 : 1
    }
  };
  const formatMeasure = str => byUnits ? str : `$ ${_formatDollar(str)}`;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: `thermometer-container ${className || ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "thermometer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "thermometer-background"
  }, /*#__PURE__*/React.createElement("div", {
    className: "thermometer-background-base"
  }), /*#__PURE__*/React.createElement("div", {
    style: defaultStyles.tubeContainer,
    className: "thermometer-tube-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "thermometer-tube"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...defaultStyles.message,
      color: body_color
    },
    className: "thermometer-message"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      background: body_color
    },
    className: `fill-indicator ${byUnits ? 'units' : ''}`
  }), /*#__PURE__*/React.createElement("span", {
    className: "thermometer-message__description"
  }, descriptionValue), /*#__PURE__*/React.createElement("span", {
    className: "thermometer-message__value"
  }, formatMeasure(value)), byUnits && /*#__PURE__*/React.createElement("span", {
    className: "units-description"
  }, "UNITS"))))), /*#__PURE__*/React.createElement("div", {
    className: "thermometer-asset"
  }, /*#__PURE__*/React.createElement(ThermometerAsset, {
    color: body_color
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      color: body_color
    },
    className: "thermometer-description"
  }, /*#__PURE__*/React.createElement("span", {
    className: "thermometer-description__text"
  }, goal_description), /*#__PURE__*/React.createElement("span", {
    style: defaultStyles.reached,
    className: "thermometer-description__text--reached"
  }, "REACHED!")), /*#__PURE__*/React.createElement("span", {
    style: {
      color: body_color
    },
    className: "thermometer-value"
  }, formatMeasure(goal), byUnits && /*#__PURE__*/React.createElement("span", {
    className: "units-description"
  }, "UNITS"))));
});
Thermometer.displayName = 'Thermometer';
export default Thermometer;